import React, { useEffect } from "react";
import "../assets/css/styles.css";

const Industries = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const industries = [
        {
            id: 1,
            number: "01",
            title: "Sports",
            subheading: "Fitness & Athletic Solutions",
            shortDesc: "Building immersive sports tech platforms",
            description:
                "The sports industry requires immersive and engaging UI/UX that we excel in developing. We help leaders launch or scale sports businesses using our technology expertise in the industry.",
            image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&h=600&fit=crop",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" stroke="currentColor" strokeWidth="2" />
                    <path d="M9.5 9L12 6.5L14.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M9.5 15L12 17.5L14.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
            ),
        },
        {
            id: 2,
            number: "02",
            title: "On-demand",
            subheading: "Real-Time Service Platforms",
            shortDesc: "Connecting users with instant services",
            description:
                "We develop on-demand apps for any industry by using the best technology available. Whatever your requirement might be, we can create an on-demand app for you as and when you need it.",
            image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
            ),
        },
        {
            id: 3,
            number: "11",
            title: "Events",
            subheading: "Event Management Technology",
            shortDesc: "Real-time event coordination solutions",
            description:
                "We develop software for the event management industry allowing users to manage their events on the go in real-time.",
            image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&h=600&fit=crop",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="6" width="18" height="15" rx="2" stroke="currentColor" strokeWidth="2" />
                    <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
                    <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
            ),
        },
        {
            id: 4,
            number: "03",
            title: "Healthcare",
            subheading: "Digital Health Innovation",
            shortDesc: "Secure healthcare technology solutions",
            description:
                "We empower healthcare organizations with cutting-edge technology solutions. From telemedicine platforms to patient management systems, we deliver secure and scalable healthcare applications.",
            image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
        },
        {
            id: 5,
            number: "04",
            title: "E-Commerce",
            subheading: "Digital Commerce Platforms",
            shortDesc: "Scalable online retail solutions",
            description:
                "We build powerful e-commerce platforms that drive sales and enhance customer experience. Our solutions include secure payment integration, inventory management, and personalized shopping experiences.",
            image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="9" cy="21" r="1" stroke="currentColor" strokeWidth="2" />
                    <circle cx="20" cy="21" r="1" stroke="currentColor" strokeWidth="2" />
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
        },
        {
            id: 6,
            number: "05",
            title: "Finance",
            subheading: "Financial Technology Solutions",
            shortDesc: "Innovative fintech applications",
            description:
                "Transform your financial services with our innovative fintech solutions. We develop secure banking apps, investment platforms, and financial management tools that comply with industry regulations.",
            image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&h=600&fit=crop",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
        },
    ];

    return (
        <div className="industries-page">
            {/* Hero Section */}

            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Industries with <span className="breadcrumb-highlight">Innovative Solutions</span>
                                </h1>
                                <p className="breadcrumb-subtitle" style={{ color: '#ddd' }}>
                                    We deliver cutting-edge technology solutions across diverse industries,
                                    helping<br /> businesses transform their operations and achieve excellence.
                                </p>
                            </div>
                            <div className="col-lg-12 align-items-center justify-content-lg-end mt-4 mt-lg-0">
                                <button className="breadcrumb-btn" style={{ alignItems: 'center' }}>
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section >

            {/* Industries Grid Section */}
            < section className="industries-grid-section padding-left-right bottom" >
                <div className="container-fluid">
                    <div className="row">
                        {industries.map((industry, index) => (
                            <div key={industry.id} className="col-lg-4 col-md-6 mt-4 industry-column"
                                style={{
                                    animation: `fadeInUp 0.6s ease-out ${index * 0.1}s forwards`,
                                    opacity: 0
                                }}>
                                <div className="industry-card">
                                    <div className="industry-image-wrapper">
                                        <img
                                            src={industry.image}
                                            alt={industry.title}
                                            className="industry-image"
                                        />
                                        <div className="industry-image-overlay"></div>
                                        <div className="industry-number">{industry.number}</div>
                                        <div className="industry-content">
                                            <div className="industry-icon">
                                                {industry.icon}
                                            </div>
                                            <h3 className="industry-title">{industry.title}</h3>
                                            <p className="industry-description">{industry.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section >
        </div >
    );
};

export default Industries;
